// extracted by mini-css-extract-plugin
export var box = "_7l-1";
export var checked = "_7l-2";
export var descriptionSpacer = "_7l-9";
export var disabled = "_7l-3";
export var icon = "_7l-6";
export var input = "_7l-0";
export var labelSpacer = "_7l-8";
export var medium = "_7l-5";
export var small = "_7l-4";
export var text = "_7l-7";